import React from 'react';
import { Col, Row, Label, Panel, OverlayTrigger, Tooltip } from 'react-bootstrap';




import { translate } from 'react-i18next';

@translate(['common'])
export default class Legend extends React.Component {

	render() {

		const {t} = this.props

		var legendArr = [
			{ label: t("legend.black"), text:t('legend.uncomplete_sheet'), background: '#000' },
			{ label: t("legend.orange"), text:t('legend.completed_sheet_notsync') , background: 'orange' },
			{ label: t("legend.blue"), text:t('legend.syncing_sheet') , background: '#0000FF' },
			{ label: t("legend.green"), text:t('legend.activated_sheet') , background: '#00FF00' },
			{ label: t("legend.red"), text:t('legend.unavaiable_sheet') , background: 'red' }
		]
		

		

		return (

			<div>

				<div style={{ float: 'right', marginRight: '10px', width: "148px" }}>
					<div> {t("legend.title")} :</div>

					<div style={{ textAlign: 'left' }}>
						{legendArr.map(({ label, text, background }) => (
							<span>
								<OverlayTrigger placement="top"
									overlay={<Tooltip id="tooltip">
										<strong>{text}</strong>
									</Tooltip>}
								>
									<Label style={{ background, width: '45px', display: "inline-block", cursor: 'pointer' }}>
										{label}
									</Label>
								</OverlayTrigger>&nbsp;

							</span>

						))}


					</div>

				</div>

			</div>

		)

	}

}